// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/styles/" + "styles" + "." + "8967aba585eda53c3782" + ".css";
};